import { Pencil } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';

const detailData = ({ title, is_active }: any = {}) => {
  return [
    { name: 'Název', value: title },
    { name: 'Aktivní', value: is_active ? 'Ano' : 'Ne' },
  ];
};

export default function BuildingModelDetailView({ data, makeEditable }) {
  const permission = useSelector((state) => state.auth.pagePermission);

  return (
    <div className="w-full">
      <Bar
        text={'Detail modelu stavby'}
        content={
          permission === 2 && data
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="building-model-edit-btn"
                  onClick={makeEditable}
                />,
              ]
            : []
        }
      />
      <List data={detailData(data || {})} />
    </div>
  );
}
